import { getNewMemberActivityName } from 'src/containers/adminDashboard/utils/groupsTranslationMap';

export const buildBaseGroupInputs = (Attendant) => ({
  civil: Attendant.civil,
  identification: Attendant.identification,
  phone: Attendant.phone,
  person1: {
    name: Attendant.name,
    lastName: Attendant.lastName,
    identification: Attendant.identification,
    phone: Attendant.phone,
    gender: Attendant.gender,
    birthdate: Attendant.birthdate,
    email: Attendant.email,
    civil: Attendant.civil,
  },
});

const normalizePreference = (preference) => {
  if (typeof preference === 'boolean') {
    return { preferMixed: preference, preferCouples: false };
  }
  if (typeof preference === 'string') {
    return {
      preferMixed: preference === 'mixed',
      preferCouples: preference === 'couples',
    };
  }
  return {
    preferMixed: Boolean(preference?.preferMixed),
    preferCouples: Boolean(preference?.preferCouples),
  };
};

export const resolveActivityName = (Attendant, preference) => {
  const { preferMixed, preferCouples } = normalizePreference(preference);
  return getNewMemberActivityName({
    gender: Attendant.gender,
    birthdate: Attendant.birthdate,
    civil: Attendant.civil,
    preferMixed,
    preferCouples,
  });
};

export const buildExistingGroupInputs = ({
  identification,
  phone,
  groupMember,
  Attendants,
  guest,
}) => ({
  identification: identification != null ? String(identification) : '',
  phone: phone != null ? String(phone) : '',
  groupMember,
  Attendants: Attendants?.length ? Attendants : guest ? [guest] : [],
  activityName: groupMember?.ChurchGroup?.activityName,
  kind: groupMember?.ChurchGroup?.kind,
  kindgroup: groupMember?.ChurchGroup?.kind,
  person1: guest
    ? {
        name: guest.name,
        lastName: guest.lastName,
        identification: guest.identification,
        phone: guest.phone,
        gender: guest.gender,
        birthdate: guest.birthdate,
        email: guest.email,
        civil: guest.civil,
      }
    : undefined,
  civil: guest?.civil,
});

export const buildGroupInputsWithActivity = (Attendant, preference) => {
  const { preferMixed, preferCouples } = normalizePreference(preference);
  const activityName = resolveActivityName(Attendant, { preferMixed, preferCouples });
  if (!activityName) return null;

  return {
    ...buildBaseGroupInputs(Attendant),
    activityName,
    kind: 'Grupo_Discipulado',
    kindgroup: 'Grupo_Discipulado',
    preferMixed,
    preferCouples,
  };
};
